import { useState } from 'react';

interface UseRepeatableFormItemsOptions {
    formik: any;
    fieldName: string;
}

export function useRepeatableFormItems<T>({ formik, fieldName }: UseRepeatableFormItemsOptions) {
    const [isAdding, setIsAdding] = useState<boolean>(false);
    const [editingIndex, setEditingIndex] = useState<null | number>(null);

    const addItem = (item: T) => {
        formik.setFieldValue(fieldName, [...formik.values[fieldName], item]);
        setIsAdding(false);
    };

    const updateEditingItem = (item: T) => {
        if (editingItem !== null) {
            formik.setFieldValue(
                fieldName,
                formik.values[fieldName].map((x: any, i: number) => (i === editingIndex ? item : x))
            );
            setEditingIndex(null);
        }
    };

    const removeItem = (index: number) => {
        const items = formik.values[fieldName];
        formik.setFieldValue(fieldName, [...items.slice(0, index), ...items.slice(index + 1)]);
    };

    const editingItem = editingIndex !== null ? (formik.values[fieldName][editingIndex] as T) : null;

    return {
        isOpen: isAdding || editingIndex !== null,
        isEditing: editingIndex !== null,
        openAdd: () => {
            setIsAdding(true);
        },
        openEdit: (index: number) => setEditingIndex(index),
        close: () => {
            setIsAdding(false);
            setEditingIndex(null);
        },
        editingItem,
        addItem,
        updateEditingItem,
        removeItem
    };
}
